export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[4],
          marginTop: theme.spacing(1),
          border: `1px solid ${theme.palette.divider}`,
        },
        list: {
          padding: theme.spacing(0.5),
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(1, 1.5),
          margin: theme.spacing(0.25, 0),
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.selected,
            },
          },
        },
      },
    },
    MuiMenuList: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0.5),
        },
      },
    },
  };
}

